module.exports = __webpack_public_path__ + "img/AdobeStock_460313941.dbdf4cd9.jpeg";